<h1 class="title">Ny användare</h1>
<div class="wrapper w-50">
  <form [formGroup]="creatAnvandareForm" (ngSubmit)="save()">
    <div class="form">
      <div *ngIf="isInternUser">
        <label for="">Användartyp </label><span class="required"> * </span>
        <select class="form-select" formControlName="anvandartyp" (change)="onAnvandartypChange()">
          <option value="null" [defaultSelected]="true">-- Välj --</option>
          <option value="Intern">Intern</option>
          <option value="Extern">Extern</option>
        </select>
        @if (creatAnvandareForm.controls.anvandartyp.touched && !creatAnvandareForm.controls.anvandartyp.dirty) {
          <p class="text-danger">* Användartyp måste väljas</p>
        }
      </div>
      <div>
        <label>Användarnamn</label><span class="required"> * </span>
        <input
          class="form-control"
          type="text"
          formControlName="anvandarnamn"
          [placeholder]="usernamePlaceholder || 'Användarnamn'"
          maxlength="50"
        />
        @if (
          creatAnvandareForm.controls.anvandarnamn.errors?.["required"] &&
          creatAnvandareForm.controls.anvandarnamn.touched
        ) {
          <p class="text-danger">* Användarnamn måste vara ifyllt</p>
        }
        <p
          *ngIf="
            creatAnvandareForm.controls.anvandarnamn.touched &&
            creatAnvandareForm.controls.anvandarnamn.errors?.['pattern']
          "
          class="text-danger"
        >
          * Användarnamnet måste matcha Personnummer format: ÅÅÅÅMMDDXXXX
        </p>
        <p
          *ngIf="
            creatAnvandareForm.controls.anvandarnamn.touched &&
            (creatAnvandareForm.controls.anvandarnamn.errors?.['maxlength'] ||
              creatAnvandareForm.controls.anvandarnamn.errors?.['minlength'])
          "
          class="text-danger"
        >
          * Användarnamn måste vara 12 siffror
        </p>
        <p
          *ngIf="
            creatAnvandareForm.controls.anvandarnamn.touched &&
            !creatAnvandareForm.controls.anvandarnamn.errors?.['maxlength'] &&
            !creatAnvandareForm.controls.anvandarnamn.errors?.['minlength'] &&
            creatAnvandareForm.controls.anvandarnamn.errors?.['invalidPersonnummer']
          "
          class="text-danger"
        >
          * {{ creatAnvandareForm.controls.anvandarnamn.errors?.["invalidPersonnummer"] }}
        </p>
        <p *ngIf="errorMsg">Användare kunde inte sparas! Kontakta Svebar IT</p>
      </div>
      <div>
        <label for="">Förnamn</label><span class="required"> * </span>
        <input class="form-control" type="text" formControlName="fornamn" maxlength="50" placeholder="Förnamn" />
        @if (
          creatAnvandareForm.controls.fornamn.touched &&
          (!creatAnvandareForm.controls.fornamn.dirty || creatAnvandareForm.controls.fornamn.invalid)
        ) {
          <p class="text-danger">* Förnamn måste vara ifyllt</p>
        }
      </div>
      <div>
        <label for="">Efternamn</label><span class="required"> * </span>
        <input class="form-control" type="text" formControlName="efternamn" maxlength="50" placeholder="Efternamn" />
        @if (
          creatAnvandareForm.controls.efternamn.touched &&
          (!creatAnvandareForm.controls.efternamn.dirty || creatAnvandareForm.controls.efternamn.invalid)
        ) {
          <p class="text-danger">* Efternamn måste vara ifyllt</p>
        }
      </div>
      <div *ngIf="isInternUser">
        <label for="">Organisation</label><span class="required"> * </span>
        <select class="form-select" formControlName="organisationId">
          <option [defaultSelected]="true" disabled>{{ defaultSelect.namn }}</option>
          <option *ngFor="let lab of filteredOrganisations" [ngValue]="lab.id">{{ lab.label }}</option>
        </select>
        @if (creatAnvandareForm.controls.organisationId.touched && !creatAnvandareForm.controls.organisationId.dirty) {
          <p class="text-danger">* Organisation måste väljas</p>
        }
      </div>
      <div>
        <label>Titel</label>
        <input
          class="form-control"
          type="text"
          formControlName="titel"
          maxlength="50"
          placeholder="Tjänstebefattning"
        />
      </div>
      <div>
        <label for="">E-post</label><span class="required"> * </span>
        <input class="form-control" type="email" email formControlName="epost" [placeholder]="epostPlaceholder" />
        @if (creatAnvandareForm.controls.epost.errors?.["required"] && creatAnvandareForm.controls.epost.touched) {
          <p class="text-danger">* E-post måste vara ifyllt</p>
        }
        @if (creatAnvandareForm.controls.epost.errors?.["pattern"]) {
          <p class="text-danger">* Ogiltigt e-post format</p>
        }
      </div>
      <div>
        <label>Mobilnummer</label><span class="required"> * </span>
        <input
          class="form-control"
          type="text"
          formControlName="telefon"
          maxlength="50"
          [placeholder]="mobilPlaceHolder"
        />
        @if (creatAnvandareForm.controls.telefon.errors?.["required"] && creatAnvandareForm.controls.telefon.touched) {
          <p class="text-danger">* Mobilnummer måste vara ifyllt</p>
        }
        @if (creatAnvandareForm.controls.telefon.errors?.["pattern"] && creatAnvandareForm.controls.telefon.touched) {
          <p class="text-danger">* Ogiltiga tecken</p>
        }
      </div>
    </div>
    <div class="roller">
      <h4 class="">Systemroller</h4>
      <div class="form-check">
        <div *ngFor="let roll of filteredAnvandarRoller; let i = index">
          <input
            type="checkbox"
            class="form-check-input"
            [(ngModel)]="roll.checked"
            [ngModelOptions]="{ standalone: true }"
          />
          <label class="form-check-label">{{ getRoleLabel(roll.roll) }}</label>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-between">
      <app-button text="Avbryt" [buttonStyle]="'secondary'" (click)="cancel()"></app-button>
      <app-button text="Registrera användare" [buttonStyle]="'primary'" type="submit" icon="plus" [disabled]="!canSave"></app-button>
    </div>
  </form>
</div>
